var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MobileGoogleAdsInterstitialPopup',{staticStyle:{"margin":"0 auto"},attrs:{"path":"/22777916944/RTBGo_Mobile_Web_PopUp_Banner_320x250","size":[320, 250],"id":"div-gpt-ad-1751603181609-0"}})}
var staticRenderFns = []

export { render, staticRenderFns }